<template>
	<div>
		<!-- 面包屑导航区域 -->
		<!-- 卡片视图区域 -->
		<el-card class="box-card">
			<!-- 搜索与添加区域 -->
			<div class="search-area">
				<el-form ref="searchForm" :model="searchForm" label-width="70px" inline size="small">
					<el-form-item label="菜单名称:">
						<el-input :clearable="true" v-model="searchForm.menuName" placeholder="请输入菜单名称" style="width: 150px;" />
					</el-form-item>
					<el-form-item label="菜单编码:">
						<el-input :clearable="true" v-model="searchForm.menuCode" placeholder="请输入菜单编码" style="width: 150px;" />
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="getMenuList()">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button v-if="isSuperAuthority" type="primary" @click="addMenuInit()">+ 添加菜单</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="changeIsExpand()">全部展开/折叠</el-button>
					</el-form-item>
				</el-form>
			</div>

			<!-- 菜单列表区 树形表格 -->
			<el-table v-if="refreshTable" :data="menuList" style="width: 100%;margin-top: 20px;" row-key="id" :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}"
			 border :default-expand-all="isExpand" :tree-props="{children: 'children'}" :stripe="true" :highlight-current-row="true">
				<el-table-column type="index" width="60"></el-table-column>
				<el-table-column prop="menuName" label="菜单名称" sortable>
				</el-table-column>
				<el-table-column prop="menuCode" label="菜单编码" sortable>
				</el-table-column>
				<el-table-column prop="parentId" label="父菜单名称">
					<template slot-scope="scope">
						{{ getParentMenuName(scope.row.parentId) }}
					</template>
				</el-table-column>
				<el-table-column prop="pagePath" label="页面路径">
				</el-table-column>
				<el-table-column prop="icon" label="菜单图标">
				</el-table-column>
				<el-table-column prop="orderNum" label="排序号" sortable>
				</el-table-column>
				<el-table-column v-if="isSuperAuthority" fixed="right" header-align="center" align="center" width="180" label="操作">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" icon="el-icon-edit" @click="updateMenuInit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteMenu(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页区域 -->
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
				style="margin-top: 20px; text-align: right;"
			></el-pagination>

			<!-- 添加菜单 -->
			<el-dialog title="添加菜单" :visible.sync="addMenuDialogVisible" width="800px">
				<!-- form表单 -->
				<el-form :model="menuForm" style="margin-right: 1.50rem;" status-icon :rules="menuRules" ref="menuForm"
				 label-width="100px" class="demo-ruleForm">
					<el-form-item label="父级菜单" prop="parentId">
						<el-select style="width: 100%;" :clearable=true v-model="menuForm.parentId" :filterable=true size="small"
						 placeholder="请选择上级菜单">
							<el-option label="根菜单" value=""></el-option>
							<el-option v-for="item in menuTree" :key="item.id" :label="item.menuName" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="菜单名称" prop="menuName">
						<el-input placeholder="请输入菜单名称" v-model="menuForm.menuName" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="菜单编码" prop="menuCode">
						<el-input placeholder="请输入菜单编码" v-model="menuForm.menuCode" size="small" :clearable=true @blur="checkMenuCode"></el-input>
						<el-alert v-if="codeError" :title="codeError" type="error" show-icon :closable=false style="margin-top: 10px;"></el-alert>
					</el-form-item>
					<el-form-item label="页面路径" prop="pagePath">
						<el-input placeholder="请输入页面路径" v-model="menuForm.pagePath" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="菜单图标" prop="icon">
						<el-input placeholder="请输入菜单图标" v-model="menuForm.icon" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="排序号" prop="orderNum">
						<el-input placeholder="请输入排序号" v-model.number="menuForm.orderNum" size="small" :clearable=true type="number"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="addMenuDialogVisible = false">取 消</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="addMenu">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 菜单修改 -->
			<el-dialog title="修改菜单" :visible.sync="updateMenuDialogVisible" width="800px">
				<!-- form表单 -->
				<el-form :model="menuForm" style="margin-right: 1.50rem;" status-icon :rules="menuRules" ref="menuForm"
				 label-width="100px" class="demo-ruleForm">
					<el-form-item label="父级菜单" prop="parentId">
						<el-select style="width: 100%;" :clearable=true v-model="menuForm.parentId" :filterable=true size="small"
						 placeholder="请选择上级菜单">
							<el-option label="根菜单" value=""></el-option>
							<el-option v-for="item in menuTree" :key="item.id" :label="item.menuName" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="菜单名称" prop="menuName">
						<el-input placeholder="请输入菜单名称" v-model="menuForm.menuName" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="菜单编码" prop="menuCode">
						<el-input placeholder="请输入菜单编码" v-model="menuForm.menuCode" size="small" :clearable=true @blur="checkMenuCode"></el-input>
						<el-alert v-if="codeError" :title="codeError" type="error" show-icon :closable=false style="margin-top: 10px;"></el-alert>
					</el-form-item>
					<el-form-item label="页面路径" prop="pagePath">
						<el-input placeholder="请输入页面路径" v-model="menuForm.pagePath" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="菜单图标" prop="icon">
						<el-input placeholder="请输入菜单图标" v-model="menuForm.icon" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="排序号" prop="orderNum">
						<el-input placeholder="请输入排序号" v-model.number="menuForm.orderNum" size="small" :clearable=true type="number"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="updateMenuDialogVisible = false">取 消</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="updateMenu">确 定</el-button>
				</span>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
export default {
	data() {
		return {
			refreshTable: true,
			isExpand: true,
			currentPage: 1,
			pageSize: 10,
			total: 0,
			searchForm: {
				menuName: '',
				menuCode: ''
			},
			menuForm: {
				orderNum: 0
			},
			menuTree: [],
			menuList: [],
			isSuperAuthority: false,
			codeError: '',
			//控制添加用户信息对话框显示与隐藏
			addMenuDialogVisible: false,
			updateMenuDialogVisible: false,
			menuRules: {
				//验证是否合法
				menuName: [{
					required: true,
					message: '请输菜单名称',
					trigger: 'blur',
				},
				{
					min: 2,
					max: 100,
					message: '长度在 2 到 100 个字符',
					trigger: 'blur',
				}
				],
				menuCode: [{
					required: true,
					message: '请输菜单编码',
					trigger: 'blur',
				},
				{
					min: 2,
					max: 100,
					message: '长度在 2 到 100 个字符',
					trigger: 'blur',
				}
				],
				pagePath: [{
					required: true,
					message: '请输页面路径',
					trigger: 'blur',
				}
				],
				orderNum: [{
					required: true,
					message: '请输排序号',
					trigger: 'blur',
				},
				{
					type: 'number',
					message: '请输入数值类型',
					trigger: 'blur',
					transform: (value) => Number(value)
				}
				]
			}
		}
	},
	created() {
		this.initCurrentRoleCode()
		this.getMenuList()
		this.getMenuTree()
	},
	methods: {
		initCurrentRoleCode() {
			const roleCodes = JSON.parse(window.sessionStorage.getItem('roleCodes') || '[]')
			const roles = JSON.parse(window.sessionStorage.getItem('roles') || '[]')
			this.isSuperAuthority = roleCodes.includes('SUPER_AUTHORITY') || roles.some(role => role.roleCode === 'SUPER_AUTHORITY')
		},
		handleSizeChange(val) {
			this.pageSize = val
			this.getMenuList()
		},
		handleCurrentChange(val) {
			this.currentPage = val
			this.getMenuList()
		},
		async getMenuList() {
			const { data: res } = await this.$http.get('/api/permission/menu/page', {
				params: {
					current: this.currentPage,
					size: this.pageSize,
					menuName: this.searchForm.menuName,
					menuCode: this.searchForm.menuCode
				}
			})
			if (res.code != 200) return this.$message.error(res.message)
			this.menuList = res.data.records
			this.total = res.data.total
		},
		async getMenuTree() {
			const { data: res } = await this.$http.get('/api/permission/menu/tree')
			if (res.code != 200) return this.$message.error(res.message)
			this.menuTree = res.data
		},
		addMenuInit() {
			this.addMenuDialogVisible = true
			this.menuForm = {
				orderNum: 0
			}
			this.codeError = ''
		},
		async addMenu() {
			this.$refs.menuForm.validate(async (valid) => {
				if (valid) {
					// 确保orderNum是数字类型
					const formData = { ...this.menuForm }
					formData.orderNum = Number(formData.orderNum)
					const { data: res } = await this.$http.post('/api/permission/menu/saveMenu', formData)
					if (res.code == 200) {
						this.addMenuDialogVisible = false
						this.getMenuList()
						this.getMenuTree()
						this.$message.success('添加成功')
					} else {
						this.$message.error(res.message)
					}
				}
			})
		},
		async checkMenuCode() {
			if (!this.menuForm.menuCode) {
				this.codeError = ''
				return
			}
			const { data: res } = await this.$http.get('/api/permission/menu/check-code', {
				params: {
					menuCode: this.menuForm.menuCode,
					id: this.menuForm.id
				}
			})
			if (res.code == 200) {
				if (res.data.exist) {
					this.codeError = '菜单编码已存在'
				} else {
					this.codeError = ''
				}
			}
		},
		deleteMenu(row) {
			this.$confirm("确认删除该菜单吗？", {
				title: "提示",
				type: 'warning',
			}).then(async () => {
				const { data: res } = await this.$http.delete(`/api/permission/menu/${row.id}`)
				if (res.code == 200) {
					this.getMenuList()
					this.getMenuTree()
					this.$message.success('删除成功')
				} else {
					this.$message.error(res.message)
				}
			})
		},
		updateMenuInit(row) {
			this.menuForm = { ...row }
			// 确保orderNum是数字类型
			this.menuForm.orderNum = Number(this.menuForm.orderNum)
			this.updateMenuDialogVisible = true
			this.codeError = ''
		},
		async updateMenu() {
			this.$refs.menuForm.validate(async (valid) => {
				if (valid) {
					// 确保orderNum是数字类型
					const formData = { ...this.menuForm }
					formData.orderNum = Number(formData.orderNum)
					const { data: res } = await this.$http.put('/api/permission/menu', formData)
					if (res.code == 200) {
						this.getMenuList()
						this.getMenuTree()
						this.updateMenuDialogVisible = false
						this.$message.success('修改成功')
					} else {
						this.$message.error(res.message)
					}
				}
			})
		},
		changeIsExpand() {
			this.refreshTable = false;
			this.isExpand = !this.isExpand;
			this.$nextTick(() => {
				this.refreshTable = true;
			});
		},
		// 根据parentId获取父菜单名称
		getParentMenuName(parentId) {
			if (!parentId) {
				return '根菜单';
			}
			// 递归查找父菜单
			const findParentMenu = (menuTree, id) => {
				for (const menu of menuTree) {
					if (menu.id == id) {
						return menu.menuName;
					}
					if (menu.children && menu.children.length > 0) {
						const result = findParentMenu(menu.children, id);
						if (result) {
							return result;
						}
					}
				}
				return '未知';
			};
			return findParentMenu(this.menuTree, parentId);
		}
	}
}
</script>

<style>
	.search-area {
		margin-bottom: 20px;
	}

	.el-radio__input.is-checked+.el-radio__label {
		color: #3CA757 !important;
	}

	.el-radio__input.is-checked .el-radio__inner {
		border-color: #3CA757 !important;
		background: #3CA757 !important;
	}
</style>